import React from 'react';
import { FormControl, InputLabel, MenuItem, Typography, Select } from '@mui/material';
import { useAppState } from '../../../../state';
import { useAudioOutputDevices } from '../deviceHooks/deviceHooks';
import { useTranslation } from 'react-i18next';

export default function AudioOutputList() {
  const audioOutputDevices = useAudioOutputDevices();
  const { activeSinkId, setActiveSinkId } = useAppState();
  const activeOutputLabel = audioOutputDevices.find((device) => device.deviceId === activeSinkId)?.label;
  const { t } = useTranslation();

  return (
    <div className="inputSelect">
      {audioOutputDevices.length > 1 ? (
        <FormControl fullWidth>
          <InputLabel id="audio-output-select-label" shrink>
            {t('select-speaker')}
          </InputLabel>
          <Select
            labelId="audio-output-select-label"
            label={t('select-speaker')}
            onChange={(e) => setActiveSinkId(e.target.value as string)}
            value={activeSinkId}
          >
            {audioOutputDevices.map((device) => (
              <MenuItem value={device.deviceId} key={device.deviceId}>
                {device.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <>
          <Typography variant="h6">{t('select-speaker')}</Typography>
          <Typography>{activeOutputLabel || t('system-default-audio-output')}</Typography>
        </>
      )}
    </div>
  );
}
